import { useState, useEffect, useContext } from 'react';
import { useForm } from '../../../hooks';

import { Typography, Button, Grid, IconButton, MenuItem } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import StyledModal from '../StyledModal';
import TextField from '../../common/TextField';
import colors from '../../../assets/colors';
import { storage } from '../../../utils/api';
import FarmContext from '../../../store/farm-context';

export default function AddWarehouseItemModal(props) {
  const farmCTX = useContext(FarmContext);
  const [isFormDataComplete, setIsFormDataComplete] = useState(false);
  const [isAmountNegative, setIsAmountNegative] = useState(false);

  const handleClose = () => props.setOpen(false);
  const handleAddWarehouseItem = () => {
    addWarehouseItem();
    handleClose();
  };

  const { handleChange, values } = useForm({
    itemName: '',
    itemQuantity: '',
    acquisitionType: '',
  });

  useEffect(() => {
    if (
      values.itemQuantity.length > 0 &&
      values.itemName.length > 0 &&
      values.acquisitionType.length > 0
    ) {
      setIsFormDataComplete(true);
    } else {
      setIsFormDataComplete(false);
    }
    if (parseFloat(values.itemQuantity) <= 0) {
      setIsAmountNegative(true);
    } else setIsAmountNegative(false);
  }, [
    values.itemName,
    values.itemQuantity,
    values.acquisitionType,
    isAmountNegative,
  ]);

  const addWarehouseItem = () => {
    const body = {
      cropName: values.itemName,
      activity: values.acquisitionType,
      amount: values.itemQuantity,
    };
    storage
      .add(farmCTX.farmID, body)
      .then(() => props.updateWarehouse())
      .catch(() => {});
  };
  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
          Dodaj zasób
        </Typography>
      </Grid>
      <Grid container direction={'row'} justifyContent="space-between">
        <Grid item xs={12} lg={4}>
          <TextField
            modal
            label="Nazwa surowca"
            onChange={handleChange('itemName')}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            modal
            label="Ilość"
            type="number"
            onChange={handleChange('itemQuantity')}
            error={isAmountNegative}
            helperText={
              isAmountNegative &&
              'Podana wartość jest mniejsza lub równa zero, podaj wartość dodatnią'
            }
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TextField
            modal
            select
            label="Sposób pozyskania zasobu"
            value={values.acquisitionType}
            sx={{ textAlign: 'left' }}
            onChange={handleChange('acquisitionType')}
            InputLabelProps={{
              shrink: values.acquisitionType ? true : false,
            }}
          >
            <MenuItem value="zakup">Zakup</MenuItem>
            <MenuItem value="wyprodukowanie">Wyprodukowanie</MenuItem>
          </TextField>
        </Grid>
      </Grid>
      <Grid container justifyContent="right">
        <Button
          type="submit"
          variant="outlined"
          onClick={handleAddWarehouseItem}
          sx={{ mt: 2 }}
          disabled={!isFormDataComplete || isAmountNegative}
        >
          Dodaj
        </Button>
      </Grid>
    </StyledModal>
  );
}
